(function(){

  const popup = document.getElementById('popup-entrega');
  if (!popup) return;

  const closeBtn = popup.querySelector('.popup-close');
  const PHONE = "5551998804091";

  const isMobile = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  let popupHistoryPushed = false;

  // ABRIR POPUP
  document.querySelectorAll('[data-entrega]').forEach(el => {
    el.addEventListener('click', () => {

      popup.classList.add('active');
      document.body.style.overflow = 'hidden';

      // 👉 controla histórico (igual drawer)
      if (isMobile && !popupHistoryPushed) {
        history.pushState({ popupEntrega: true }, '');
        popupHistoryPushed = true;
      }

    });
  });

  // FECHAR
  function closePopup() {
    popup.classList.remove('active');
    document.body.style.overflow = '';

    // 🚫 NÃO dá history.back()
    popupHistoryPushed = false;
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePopup();
  });

  // BOTÃO VOLTAR DO CELULAR
  window.addEventListener('popstate', function () {

    if (!isMobile) return;

    if (popup.classList.contains('active')) {

      popup.classList.remove('active');
      document.body.style.overflow = '';

      popupHistoryPushed = false;
    }

  });

  // CLICK NOS BOTÕES → WHATSAPP
  document.querySelectorAll('.btn-region').forEach(btn => {
    btn.addEventListener('click', () => {

      const message = btn.dataset.message;
      const encoded = encodeURIComponent(message);

      const url = `https://api.whatsapp.com/send?phone=${PHONE}&text=${encoded}`;

      window.open(url, '_blank');

    });
  });

})();